var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MarqueeWrapper',[_c('marquee-text',{attrs:{"duration":5,"repeat":15}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.Copy)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }